export const APT_TYPE = {
  A01: '아파트',
  A02: '주상복합',
  C01: '아파트분양권',
  C03: '주상복합분양권',
  A03: '재건축',
};

export const OFFICETEL_TYPE = {
  B01: '오피스텔',
  C02: '오피스텔분양권',
};

export const VILLA_TYPE = {
  D01: '빌라/연립',
  E01: '단독/다가구',
  E02: '전원주택',
  E03: '상가주택',
  E04: '한옥주택',
};

export const ONEROOM_TYPE = {
  G01: '원룸',
};

export const ONEROOM_VALUE = {
  '1': '원룸',
  '2': '투룸',
};

export const BUILDING_TYPE = {
  ...APT_TYPE,
  ...OFFICETEL_TYPE,
  ...VILLA_TYPE,
  ...ONEROOM_TYPE,
};

export type BuildingTypeKey = keyof typeof BUILDING_TYPE;

export const REDEVELOP_TYPE = {
  K01: '재개발',
};

export const REDEVELOP_VALUE = {
  '1': '단독/다가구',
  '2': '다세대/연립',
  '3': '기타',
};

export const MULTI_FAMILY_MEMUL_TYPE = {
  apt: '아파트',
  officetel: '오피스텔',
};

export const SINGLE_FAMILY_MEMUL_TYPE = {
  oneroom: '원·투룸​',
  villa: '빌라·주택',
  redevelop: '재개발',
};

export const MEMUL_TYPE = {
  oneroom: '원·투룸​',
  apt: '아파트',
  officetel: '오피스텔',
  villa: '빌라·주택',
  redevelop: '재개발',
};
export type MemulTypeKey = keyof typeof MEMUL_TYPE;

export const BUSINESS_DIV_TYPE = {
  S: '매매',
  Y: '전세',
  M: '월세',
  T: '단기임대',
};

export type BusinessDivKey = keyof typeof BUSINESS_DIV_TYPE;
